import { reducer } from "./reducer"
export const StockDocumentReducer = reducer

export * from "./types"



// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/reducers/index.ts